export default "__VITE_ASSET__57194bc1__"